{
  "fields": {
    "first_name": "Förnamn",
    "last_name": "Efternamn",
    "email_address": "E-postadress",
    "password": "Lösenord",
    "confirm_password": "Bekräfta lösenord",
    "email": "E-post",
    "course_name": "Bannamn",
    "location": "Plats",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "street_address": "Gatuadress",
    "city": "Stad",
    "country": "Land",
    "gender": "Kön",
    "player": "Spelare",
    "team": "Lag",
    "series": "Serie",
    "players": "Spelare",
    "flight": "Flight",
    "tee": "Tee",
    "slope": "Slope",
    "status": "Status",
    "start_time": "Starttid",
    "hole": "Hål",
    "club": "Klubb",
    "total": "Tot.",
    "tees": "Tees",
    "course": "Bana",
    "date": "Datum",
    "member_number": "Medlemsnummer",
    "birth_date": "Födelsedatum",
    "tee_color": "Tee-färg"
  },
  "actions": {
    "cancel": "Avbryt",
    "edit": "Redigera",
    "delete": "Ta bort",
    "create": "Skapa",
    "update": "Uppdatera",
    "select": "Välj",
    "clear": "Rensa",
    "activate": "Aktivera",
    "deactivate": "Inaktivera",
    "previous": "Föregående",
    "next": "Nästa",
    "add": "Lägg till",
    "save": "Spara",
    "saving": "Sparar...",
    "close": "Stäng",
    "select_all": "Välj alla",
    "remove": "Ta bort",
    "continue": "Fortsätt",
    "submit": "Skicka",
    "confirm": "Bekräfta",
    "show": "Visa",
    "hide": "Dölj",
    "delete_selected": "Ta bort valda",
    "undo": "Ångra",
    "export_pdf": "Ladda ner PDF",
    "activate_selected": "Aktivera valda",
    "deactivate_selected": "Inaktivera valda",
    "loading": "Laddar...",
    "load_more": "Visa mer",
    "like": "Gilla",
    "comment": "Kommentera",
    "continue_to_payment": "Fortsätt till betalning",
    "pay_later": "Betalar senare",
    "submitting": "Skickar...",
    "redirecting_to_payment": "Omdirigerar till betalning...",
    "pay_participation": "Betala deltagande",
    "deleted": "Raderad",
    "copy": "Kopiera",
    "more": "Fler åtgärder",
    "deselect_all": "Avmarkera alla"
  },
  "status": {
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "verified": "Verifierad",
    "unverified": "Overifierad",
    "loading": "Laddar...",
    "processing": "Bearbetar...",
    "creating": "Skapar...",
    "in_progress": "Pågår",
    "please_wait": "Vänta...",
    "changes_saved": "Ändringar sparade",
    "logging_out": "Loggar ut...",
    "adding": "Lägger till...",
    "playing": "Spelar",
    "completed": "Klar"
  },
  "labels": {
    "status": "Status",
    "created": "Skapad",
    "actions": "Åtgärder",
    "required": "*",
    "n_a": "Ej tillgänglig",
    "today": "Idag",
    "total": "Total",
    "error": "Fel",
    "not_set": "Inte angiven",
    "back": "Tillbaka",
    "new": "Ny",
    "go_back": "Gå tillbaka"
  },
  "gender": {
    "not_specified": "Ej angivet",
    "male": "Man",
    "female": "Kvinna",
    "other": "Annat"
  },
  "navigation": {
    "dashboard": "Instrumentbräda",
    "logout": "Logga ut",
    "roles": {
      "PLAYER": {
        "items": {
          "dashboard": "Instrumentpanel",
          "friends": "Vänner",
          "competitions": "Tävlingar",
          "profile": "Profil",
          "stats": "Statistik",
          "events": "Evenemang",
          "rankings": "Ranking",
          "ranking": "Ranking",
          "calendar": "Evenemangskalender",
          "series": "Rankingserier"
        }
      },
      "MANAGER": {
        "items": {
          "dashboard": "Instrumentpanel",
          "competitions": "Tävlingar",
          "administration": "Administration",
          "settings": "Inställningar",
          "events": "Evenemang",
          "rankings": "Rankingserie",
          "reports": "Rapporter",
          "ranking": "Ranking",
          "calendar": "Kalender",
          "series": "Rankingserier",
          "pointSystems": "Poängsystem",
          "courseStats": "Banstatistik",
          "payments": "Betalningsrapport",
          "scheduleTemplates": "Schemamallar",
          "scorecardTemplates": "Resultatkortmallar",
          "createEvent": "Skapa evenemang",
          "analyticsAdmin": "Analys",
          "templates": "Mallar",
          "categories": "Kategorier",
          "addOns": "Tilläggstjänster",
          "polls": "Enkäter"
        }
      },
      "SUPERUSER": {
        "items": {
          "dashboard": "Instrumentpanel",
          "competitions": "Tävlingar",
          "users": "Användare",
          "tenants": "Klubbar",
          "administration": "Administration",
          "rankings": "Ranking och Order of Merit",
          "reports": "Rapporter",
          "ranking": "Ranking",
          "clubs": "Klubbar",
          "calendar": "Kalender",
          "series": "Rankingserier",
          "pointSystems": "Poängsystem",
          "courseStats": "Banstatistik",
          "payments": "Betalningsrapport",
          "scheduleTemplates": "Schemamallar",
          "scorecardTemplates": "Resultatkortmallar",
          "handicapRecommendations": "Handikapprekommendationer",
          "other": "Övrigt",
          "settings": "Inställningar",
          "super": "Super",
          "createEvent": "Skapa evenemang",
          "analyticsAdmin": "Analys",
          "templates": "Mallar",
          "emailLog": "E-post",
          "categories": "Kategorier",
          "addOns": "Tilläggstjänster",
          "polls": "Enkäter"
        }
      }
    },
    "actions": {
      "open_menu": "Öppna meny",
      "close_menu": "Stäng meny",
      "logout": "Logga ut"
    },
    "menu": "Meny",
    "courseAnalytics": "Statistik",
    "megamenu": {
      "dashboard": "Startsida",
      "events": "Evenemang",
      "competitions": "Evenemang",
      "ranking": "Ranking",
      "pointSystems": "Poängsystem",
      "series": "Rankingserier",
      "friends": "Vänner",
      "stats": "Statistik",
      "profile": "Profil",
      "administration": "Administration",
      "settings": "Inställningar",
      "templates": "Mallar",
      "calendar": "Evenemangskalender",
      "reports": "Rapporter",
      "other": "Övrigt",
      "super": "Super",
      "analyticsAdmin": "Analys",
      "courseStats": "Banstatistik",
      "payments": "Betalningsrapport",
      "scheduleTemplates": "Schemamallar",
      "scorecardTemplates": "Resultatkortmallar",
      "users": "Användare",
      "handicapRecommendations": "Handikapprekommendationer",
      "clubs": "Klubbar",
      "tenants": "Kunder",
      "createEvent": "Skapa evenemang",
      "emailLog": "E-post",
      "categories": "Kategorier",
      "addOns": "Tilläggstjänster",
      "polls": "Enkäter"
    }
  },
  "admin": {
    "user_management": "Användarhantering",
    "manage_users_desc": "Hantera användarkonton och behörigheter",
    "all_users": "Alla användare",
    "failed_to_load_users": "Misslyckades med att ladda användare"
  },
  "validation": {
    "email_required": "E-postadress krävs",
    "email_invalid": "Ange en giltig e-postadress",
    "password_required": "Lösenord krävs",
    "password_min_length": "Lösenordet måste vara minst 8 tecken",
    "password_needs_uppercase": "Lösenordet måste innehålla minst en versal",
    "password_needs_lowercase": "Lösenordet måste innehålla minst en gemen",
    "password_needs_number": "Lösenordet måste innehålla minst en siffra",
    "confirm_password_required": "Bekräfta ditt lösenord",
    "passwords_dont_match": "Lösenorden matchar inte",
    "course_name_required": "Bannamn krävs",
    "latitude_required": "Latitud krävs",
    "longitude_required": "Longitud krävs",
    "holes_must_be_between_1_18": "Antal hål måste vara mellan 1 och 18",
    "could_not_get_location": "Kunde inte hämta din plats. Vänligen ange koordinater manuellt.",
    "geolocation_not_supported": "Geolokalisering stöds inte av din webbläsare",
    "validation_error": "Kontrollera dina data. Banbetyg måste vara mellan 40-90 och lutningsbetyg mellan 55-155.",
    "server_error_check_data": "Serverfel. Kontrollera att banbetyg är mellan 40-90 och lutningsbetyg mellan 55-155.",
    "password_needs_special": "Lösenordet måste innehålla minst ett specialtecken",
    "form_has_errors": "Formuläret innehåller fel. Korrigera felen innan du sparar."
  },
  "confirm": {
    "delete": {
      "header": "Bekräfta borttagning",
      "body": "Är du säker på att du vill ta bort detta objekt? Denna åtgärd kan inte ångras."
    },
    "unsaved_changes_title": "Osparade ändringar",
    "unsaved_changes": "Du har osparade ändringar. Vill du verkligen fortsätta?",
    "save_and_continue": "Spara ändringar",
    "continue_without_saving": "Fortsätt utan att spara"
  },
  "users": {
    "search_placeholder": "Sök efter namn eller e-post...",
    "search_failed": "Det gick inte att söka användare",
    "no_results": "Inga användare hittades"
  },
  "breadcrumbs": {
    "welcome_back": "Välkommen tillbaka",
    "user_management": "Användarhantering",
    "scorecard_management": "Scorekortshantering",
    "scorecard_view": "Scorekort",
    "profile": "Profil",
    "administration": "Administration",
    "settings": "Inställningar",
    "competition_calendar": "Tävlingskalender",
    "new_competition": "Ny tävling",
    "payment_report": "Betalningsrapport",
    "reports": "Rapporter"
  },
  "batch_actions": "Åtgärder",
  "batch_actions_disabled": "Välj först objekt",
  "loading": "Laddar...",
  "optional": "Valfritt",
  "placeholders": {
    "enter_email": "Ange e-postadress",
    "enter_password": "Ange lösenord"
  },
  "errors": {
    "generic": "Ett fel uppstod. Försök igen.",
    "export_failed": "Skapandet av PDF misslyckades",
    "accessDenied": "Åtkomst nekad",
    "managerAccessRequired": "Visning av denna sida kräver behörighet på managernivå.",
    "failed_to_load": "Inläsningen misslyckades",
    "failed_to_save": "Sparandet misslyckades",
    "no_courses_available": "Inga banor tillgängliga",
    "Failed to update round": "Det gick inte att uppdatera rundan",
    "Irish Rumble requires exactly 4 players per team": "Irish Rumble kräver exakt 4 spelare per lag",
    "Irish Rumble requires all series to allow exactly 4 players per team.": "Irish Rumble kräver att alla serier tillåter exakt 4 spelare per lag.",
    "Irish Rumble requires at least one series to be configured before creating a round.": "Irish Rumble kräver att minst en serie är konfigurerad innan en runda kan skapas.",
    "Cannot link to ranking series without a default point system. Please configure a default point system for": "Det går inte att länka till en rankingserie utan ett standardpoängsystem. Konfigurera ett standardpoängsystem för",
    "Minimum team size must be at least": "Minsta lagstorlek måste vara minst",
    "Maximum team size must be at least": "Största lagstorlek måste vara minst",
    "Minimum team size must be less than or equal to maximum team size": "Minsta lagstorlek måste vara mindre än eller lika med största lagstorlek",
    "Cannot set team size to {min}-{max} because this competition has Irish Rumble rounds which require exactly 4 players per team": "Lagstorlek kan inte ställas in på {{min}}-{{max}} eftersom tävlingen har Irish Rumble-rundor som kräver exakt 4 spelare per lag"
  },
  "administration": {
    "title": "Administration",
    "courseAnalytics": {
      "title": "Banstatistik",
      "description": "Analysera banans svårighetsgrad, poängfördelningar och hålspecifik statistik"
    },
    "timeScheduleTemplates": {
      "title": "Schemamallar",
      "description": "Hantera målschemamallar för speltempovarninar och spelaruppföljning"
    },
    "pointSystems": {
      "title": "Poängsystem",
      "description": "Hantera rankingpoängsystem och poängfördelningar"
    },
    "handicapRecommendations": {
      "title": "Handikapprekommendationer",
      "description": "Hantera Golfförbundets handikapprekkommendationer för olika speltyper"
    },
    "scorecards": {
      "title": "Resultatkortmallar",
      "description": "Hantera resultatkortmallar och baninformation"
    },
    "tenants": {
      "title": "Klubbar",
      "description": "Hantera klubbar och samfund"
    },
    "paymentReport": {
      "title": "Betalningsrapport",
      "description": "Visa och filtrera tävlingsavgifter",
      "fromDate": "Från",
      "toDate": "Till",
      "status": "Status",
      "allStatuses": "Alla statusar",
      "search": "Sök",
      "date": "Datum",
      "payer": "Betalare",
      "type": "Typ",
      "competition": "Tävling",
      "statusColumn": "Status",
      "net": "Netto",
      "vat": "Moms",
      "total": "Totalt",
      "noPayments": "Inga betalningar",
      "summaryTotal": "Totalt ({{count}} betalningar)",
      "exportPdf": "Ladda ner PDF",
      "pdfColumns": "PDF-kolumner",
      "statuses": {
        "created": "Skapad",
        "pending": "Väntar",
        "completed": "Betald",
        "failed": "Misslyckad",
        "cancelled": "Avbruten",
        "expired": "Utgången",
        "partially_refunded": "Delvis återbetald",
        "fully_refunded": "Återbetald"
      },
      "allTenants": "Alla klubbar",
      "batchActions": "Åtgärder",
      "batchActionsDisabled": "Välj betalningar först",
      "refund": {
        "action": "Återbetala valda ({{count}} st)",
        "modalTitle": "Bekräfta återbetalning",
        "reasonLabel": "Orsak till återbetalning",
        "reasonPlaceholder": "Välj orsak",
        "notesLabel": "Ytterligare information",
        "notesPlaceholder": "Valfri tilläggsinformation",
        "notesRequired": "Ytterligare information krävs när orsaken är \"Annan orsak\"",
        "warning": "Återbetalning är en oåterkallelig åtgärd.",
        "confirmButton": "Återbetala",
        "successMessage": "{{count}} betalningar återbetalda",
        "partialSuccessMessage": "{{successCount}} betalningar återbetalda, {{failCount}} misslyckades",
        "failMessage": "Återbetalning misslyckades",
        "totalAmount": "Totalt belopp att återbetala",
        "reasons": {
          "CUSTOMER_REQUEST": "Kundens begäran",
          "COMPETITION_CANCELLED": "Tävling inställd",
          "DUPLICATE_PAYMENT": "Dubbelbetalning",
          "PARTICIPANT_WITHDRAWN": "Deltagare har dragit sig ur",
          "OVERCHARGE": "Överdebitering",
          "OTHER": "Annan orsak"
        }
      },
      "types": {
        "competition_fee": "Tävlingsavgift",
        "registration_intent": "Registreringsavgift"
      },
      "paytrailDetails": {
        "title": "Paytrail-betalningsinformation",
        "loadError": "Hämtning av betalningsinformation från Paytrail misslyckades",
        "transactionId": "Transaktions-ID",
        "status": "Status",
        "provider": "Betalningssätt",
        "amount": "Summa",
        "stamp": "Identifieringskod",
        "reference": "Referens",
        "createdAt": "Skapad",
        "paidAt": "Betald",
        "filingCode": "Arkiveringskod",
        "cardInfo": "Kortuppgifter",
        "href": "Betalningssida"
      },
      "kicker": "Betalningsrapport · Evenemang",
      "period": "Period",
      "club": "Klubb",
      "filter": "Filter",
      "page": "Sida",
      "paymentsUnit": "betalningar",
      "paymentsSection": "Betalningar",
      "rowsMeta": "{{rows}} rader · sida {{page}} / {{pages}}",
      "pageTotal": "Sida totalt",
      "selectedUnit": "betalningar valda",
      "refundSelected": "Återbetala valda",
      "pdfPages": "Sidor",
      "pdfAllPages": "Alla sidor ({{count}} rader)",
      "pdfCurrentPage": "Denna sida ({{count}} rader)",
      "pdfFooterPage": "Sida {{page}} / {{pages}}",
      "rowsMetaAll": "{{rows}} rader"
    },
    "users": {
      "title": "Användare",
      "description": "Hantera användare och behörigheter"
    },
    "emailLog": {
      "title": "E-post",
      "description": "Lista över skickade e-postmeddelanden"
    },
    "polls": {
      "title": "Enkäter",
      "description": "Hantera banans feedbackenkäter och granska resultaten"
    }
  },
  "reports": {
    "courseAnalytics": {
      "title": "Banstatistik",
      "description": "Analysera banans svårighetsgrad, poängfördelningar och hålspecifik statistik"
    },
    "paymentReport": {
      "title": "Betalningsrapport",
      "description": "Visa och filtrera tävlingsbetalningar"
    },
    "title": "Rapporter"
  },
  "settings": {
    "title": "Inställningar"
  },
  "roles": {
    "display_names": {
      "PLAYER": "Spelare",
      "MANAGER": "Manager",
      "CADDIEMASTER": "Caddiemaster",
      "SUPERUSER": "Superanvändare"
    }
  },
  "rankings": {
    "title": "Rankingserier",
    "subtitle": "Hantera rankingserier och resultattavlor",
    "series_count_one": "{{count}} rankingserie",
    "series_count_other": "{{count}} rankingserier",
    "no_series": "Inga rankingserier ännu",
    "no_series_for_season": "Inga rankingserier för säsongen {{season}}",
    "create_first": "Skapa första ranking",
    "create_ranking_series": "Skapa rankingserie",
    "edit_ranking_series": "Redigera rankingserie",
    "update_ranking_series": "Uppdatera rankingserie",
    "configure_subtitle": "Konfigurera rankingserie",
    "failed_to_load": "Det gick inte att ladda rankings",
    "failed_to_load_series": "Det gick inte att ladda rankingserien",
    "failed_to_save": "Det gick inte att spara rankingserien",
    "failed_to_delete": "Det gick inte att ta bort rankingserien",
    "deleted_success": "Rankingserien har tagits bort",
    "created_success": "Rankingserien har skapats",
    "updated_success": "Rankingserien har uppdaterats",
    "confirm_delete": "Är du säker på att du vill ta bort \"{{name}}\"?",
    "delete_series_warning_title": "Ta bort rankingserie",
    "delete_series_warning_body": "Den här rankingserien har {{count}} rankingevenemang. Borttagning kopplar bort alla evenemang, resultat och poäng. Detta kan inte ångras.",
    "click_to_edit": "Klicka för att redigera",
    "saving": "Sparar...",
    "no_ranking_series_available": "Inga rankingserier tillgängliga",
    "select_ranking_series_help": "Välj rankingserier som den här tävlingsserien tillhör. Tävlingens resultat visas i de valda rankingarnas resultattabeller.",
    "filters": {
      "all_seasons": "Alla säsonger",
      "all_tenants": "Alla klubbar",
      "no_tenant": "Ingen klubb"
    },
    "cards": {
      "basic_info": "Grunduppgifter",
      "calculation_settings": "Beräkningsinställningar"
    },
    "tabs": {
      "info": "Inställningar",
      "events": "Tävlingar",
      "leaderboard": "Resultattabell"
    },
    "fields": {
      "name": "Namn",
      "name_required": "Namn är obligatoriskt",
      "name_placeholder": "t.ex. 2024 Klubbmästerskap",
      "description": "Beskrivning",
      "description_placeholder": "Valfri beskrivning",
      "category": "Kategori",
      "importance_category": "Viktighetskategori",
      "season_year": "Säsong",
      "start_date": "Startdatum",
      "start_date_required": "Startdatum är obligatoriskt",
      "end_date": "Slutdatum",
      "calculation_method": "Beräkningsmetod",
      "calculation_method_points": "Poängtabell (placeringsbaserade poäng)",
      "calculation_method_stableford_hcp": "Stablefordpoäng (handicap, summa av stablefordresultat)",
      "calculation_method_stableford_scr": "Stablefordpoäng (scratch, summa av stablefordresultat)",
      "calculation_help_points": "Poäng fördelas enligt placeringar baserat på poängsystemet",
      "calculation_help_stableford": "Summerar poängbogey-poäng från tävlingar (handikapp eller scratch enligt val)",
      "maximum_events": "Maximalt antal evenemang att beräkna (valfritt)",
      "maximum_events_placeholder": "t.ex. 6",
      "maximum_events_help_optional": "Lämna tomt för att beräkna alla evenemang. Ange ett tal för att beräkna endast de X bästa evenemangen (t.ex. bästa 6/10)",
      "tie_handling": "Hantering av lika resultat",
      "tie_handling_tied_best": "Bästa vid lika – Alla spelare med lika resultat får poäng för den bästa placeringen (generöst)",
      "tie_handling_split": "Dela poäng – Poängen delas som ett genomsnitt mellan spelare med lika resultat (rättvist)",
      "tie_handling_strict": "Exakt resultatberäkning – Använd tävlingens lösning för lika resultat (tävlingsinriktat)",
      "tie_handling_help": "Hur poäng fördelas vid lika resultat. Exempel: 3 spelare lika på plats 2 (poäng: 17, 15, 13). Bästa: alla får 17 p. Delat: (17 + 15 + 13) / 3 = 15 p för alla. Exakt: tävlingens modell för lika resultat avgör 2., 3., 4. → 17 p, 15 p, 13 p",
      "point_system": "Standardpoängsystem (valfritt)",
      "point_system_none": "-- Ingen standard (välj per evenemang) --",
      "point_system_help": "Kan ändras när evenemang länkas",
      "is_public": "Offentlig",
      "is_public_help": "När vald kan spelare se den här rankingens resultattabell",
      "tenant": "Klubb",
      "tenant_required": "Klubb är obligatorisk",
      "tenant_placeholder": "-- Välj klubb --"
    },
    "table": {
      "name": "Namn",
      "season": "Säsong",
      "period": "Period",
      "method": "Metod",
      "events": "Tävlingar",
      "status": "Status",
      "actions": "Åtgärder",
      "best_x_of_y": "Bästa {{max}}/Y",
      "all_events": "Alla tävlingar",
      "stableford": "Stableford",
      "tenant": "Klubb"
    },
    "status": {
      "draft": "UTKAST",
      "active": "AKTIV",
      "completed": "KLAR",
      "archived": "ARKIVERAD"
    },
    "actions": {
      "view_leaderboard": "Visa resultattavla",
      "manage_events": "Hantera evenemang",
      "back_to_rankings": "Tillbaka till rankings",
      "edit": "Redigera",
      "delete": "Ta bort",
      "cancel": "Avbryt"
    },
    "leaderboard": {
      "title": "{{name}}",
      "subtitle": "{{year}} Säsongens resultattavla",
      "no_standings": "Inga resultat ännu",
      "no_standings_help": "Länka och publicera serier för att skapa rankingresultat",
      "method": "Metod",
      "method_points_table": "Poängtabell",
      "method_stableford": "Stableford",
      "method_best_x": "Bästa {{max}}/{{total}}",
      "method_simple": "Enkel summa",
      "tie_handling": "Hantering av lika resultat",
      "tie_split": "Dela poäng",
      "tie_best": "Delad placering",
      "tie_strict": "Exakt countback",
      "tie_standard": "Standard",
      "events_published": "Evenemang: {{published}} / {{total}} publicerade",
      "rank": "Plats",
      "player": "Spelare",
      "total": "Totalt",
      "event": "Evenemang",
      "position": "Placering",
      "points": "Poäng",
      "status": "Status",
      "actions": "Åtgärder",
      "loading_events": "Laddar evenemang...",
      "no_events_found": "Inga evenemang",
      "failed_to_load": "Det gick inte att ladda resultattavlan",
      "failed_to_load_points": "Det gick inte att ladda spelarens poäng",
      "not_found": "Rankingserien hittades inte",
      "table": {
        "rank": "Plats",
        "player": "Spelare",
        "points": "Poäng",
        "events": "Evenemang",
        "counted": "Räknade",
        "first": "1.",
        "second": "2.",
        "third": "3."
      },
      "events_modal_title": "Evenemang",
      "events_help": "Endast poäng från publicerade evenemang visas i rankingen.",
      "method_stableford_hcp": "Stableford HCP",
      "method_stableford_scr": "Stableford SCR",
      "read_more": "Läs mer",
      "read_less": "Visa mindre",
      "legend_not_counted": "Räknas inte in i totalpoängen",
      "legend_excluded": "Tvingat undantag"
    },
    "events": {
      "title": "Evenemang - {{name}}",
      "subtitle": "Länka tävlingsserier och publicera poäng",
      "no_events": "Inga länkade evenemang ännu",
      "link_first": "Länka första serie",
      "link_series": "Länka serie",
      "failed_to_load": "Det gick inte att ladda evenemang",
      "failed_to_link": "Det gick inte att länka serien",
      "publish_title": "Publicera poäng",
      "unpublish_title": "Avpublicera",
      "failed_to_publish": "Det gick inte att publicera poängen",
      "failed_to_unpublish": "Det gick inte att avpublicera",
      "failed_to_delete": "Det gick inte att ta bort evenemanget",
      "linked_success": "Serie länkad till rankinglistan",
      "published_success": "Poäng publicerade",
      "unpublished_success": "Publicering återkallad",
      "deleted_success": "Evenemang borttaget från rankinglistan",
      "confirm_publish": "Publicera poäng för detta evenemang? Detta beräknar och fördelar rankingpoäng.",
      "confirm_unpublish": "Återkalla publicering? Detta tar bort alla rankingpoäng från detta evenemang.",
      "confirm_delete": "Ta bort \"{{name}}\" från denna ranking?",
      "select_both": "Välj både serie och poängsystem",
      "only_single_weekly": "Endast individuella tävlingar och veckotävlingar kan länkas till ranking",
      "best_x_events": "Bästa {{max}}/{{total}} evenemang",
      "total_events": "{{total}} evenemang totalt",
      "events_published_count": "{{published}} publicerade",
      "table": {
        "order": "#",
        "series": "Tävlingsserie",
        "point_system": "Poängsystem",
        "status": "Status",
        "published": "Publicerad",
        "actions": "Åtgärder",
        "status_published": "Publicerad",
        "status_unpublished": "Ej publicerad",
        "publish": "Publicera",
        "unpublish": "Avpublicera",
        "unpublish_help": "(för korrigeringar)",
        "point_system_stableford_hcp": "Poängbogey (handikapp)",
        "point_system_stableford_scr": "Poängbogey (scratch)"
      },
      "modal": {
        "title": "Länka tävlingsserie",
        "competition_label": "Tävling",
        "search_competition": "Sök tävling",
        "search_placeholder": "Sök på tävlingens namn",
        "searching": "Söker...",
        "no_results": "Inga resultat",
        "competition_select": "-- Välj tävling --",
        "series_label": "Serie",
        "series_select": "-- Välj serie --",
        "no_series_available": "Inga serier tillgängliga",
        "select_competition_first": "Välj tävling först",
        "point_system": "Poängsystem",
        "point_system_select": "-- Välj poängsystem --",
        "point_system_help": "Poäng som fördelas baserat på placering",
        "cancel": "Avbryt",
        "link": "Länka serie"
      },
      "select_series": "Välj serie"
    },
    "importance_category": {
      "minor": "Liten tävling",
      "custom": "Anpassad",
      "major": "Major-tävling",
      "standard": "Normal tävling"
    },
    "point_systems": {
      "page_title": "Poängsystem",
      "title": "Poängsystem",
      "create_new": "Skapa ny",
      "create_first": "Skapa det första poängsystemet",
      "edit_system": "Redigera poängsystem",
      "no_systems": "Inga poängsystem ännu",
      "point_allocations": "Poängfördelningar",
      "positions": "platser",
      "points_required": "Poäng är obligatoriska",
      "points_help": "Ange poäng separerade med komma, från högst till lägst (t.ex. 50, 40, 35, 30...)",
      "system_default": "Standardsystem",
      "custom": "Anpassad",
      "type": "Typ",
      "created_success": "Poängsystem skapat",
      "updated_success": "Poängsystem uppdaterat",
      "deleted_success": "Poängsystem borttaget",
      "failed_to_save": "Det gick inte att spara poängsystemet",
      "failed_to_delete": "Det gick inte att ta bort poängsystemet",
      "confirm_delete": "Vill du verkligen ta bort \"{{name}}\"?",
      "delete_title": "Ta bort poängsystem",
      "create_for": "Skapa för",
      "system_default_option": "Systemstandard (alla klubbar)",
      "tenant_label": "Klubb",
      "cannot_delete_in_use_series": "Poängsystemet kan inte tas bort eftersom det används i {{count}} rankingserier",
      "cannot_delete_in_use_events": "Poängsystemet kan inte tas bort eftersom det används i {{count}} rankingevenemang",
      "cannot_delete_in_use_both": "Poängsystemet kan inte tas bort eftersom det används i {{seriesCount}} rankingserier och {{eventsCount}} rankingevenemang"
    },
    "exclusion": {
      "exclude_result": "Exkludera resultat",
      "include_result": "Inkludera resultat",
      "exclusion_reason": "Orsak till exkludering",
      "excluded_success": "Resultat exkluderat från ranking",
      "included_success": "Resultat inkluderat i ranking",
      "failed_to_update": "Det gick inte att uppdatera exkluderingen",
      "status": {
        "excluded": "Exkluderat",
        "not_counted": "Räknas inte",
        "counted": "Räknas"
      }
    },
    "no_point_system": "Inget poängsystem",
    "configure_point_system_first": "Ange ett standardpoängsystem för rankingserien innan du länkar.",
    "configure": "Konfigurera",
    "navigate_away_title": "Gå till rankinginställningar?",
    "navigate_away_warning": "Du kan ha osparade ändringar. Är du säker på att du vill gå till rankinginställningarna?",
    "public_rankings": "Offentlig ranking"
  },
  "update": {
    "title": "Uppdaterar till ny version..."
  },
  "gender_plural": {
    "not_specified": "Ej specificerad",
    "male": "Herrar",
    "female": "Damer",
    "other": "Övriga"
  },
  "favorites": {
    "add": "Lägg till i favoriter",
    "remove": "Ta bort från favoriter"
  },
  "weather": {
    "banner": {
      "warning_title": "Vädervarning",
      "delayed_title": "Spelet avbrutet",
      "eta": "Beräknad återstarttid {{time}}",
      "no_eta": "Spelet återupptas vid en tidpunkt som meddelas senare"
    },
    "button": {
      "none_tooltip": "Vädervarning (inga varningar)",
      "warning_tooltip": "Vädervarning aktiv",
      "delayed_tooltip": "Spelet avbrutet",
      "aria_none": "Vädervarning",
      "aria_warning": "Vädervarning aktiv",
      "aria_delayed": "Spelet avbrutet"
    },
    "modal": {
      "title": "Vädervarning",
      "stage_label": "Status",
      "stage_none": "Ingen varning",
      "stage_warning": "Vädervarning",
      "stage_delayed": "Spelet avbrutet",
      "reason_label": "Orsak",
      "reason_placeholder": "T.ex. Åskväder på väg",
      "eta_label": "Beräknad återstarttid (valfritt)",
      "eta_hint": "Lämna tomt om återstarttiden inte är känd",
      "reason_required": "Orsak är obligatorisk när vädervarning är aktiv",
      "save_button": "Spara",
      "cancel_button": "Avbryt"
    }
  },
  "error_occurred": "Ett fel uppstod. Försök igen."
}
